import React from "react";
import placeholderImage from "../../../assets/images/img_placeholder.jpg";

import styles from "./Card.module.css";
import classNames from "classnames";
import { ENV } from "../../../env";

import { generateRitzCarltonDetailsLink } from "../../../utils/generateRitzCarltonDetailsLink";

const Card = ({
  image,
  icon,
  chip,
  title,
  rating,
  description,
  price,
  fee,
  reviewCount,
  isPassion,
  bookNow,
  propertyData,
  onClick,
}) => {
  // Generate appropriate hotel details link based on brand
  const getHotelDetailsLink = () => {
    if (propertyData?.marshaBrandCode === "RZ" && propertyData?.name) {
      try {
        return generateRitzCarltonDetailsLink({
          marshaCode: propertyData.id,
          propertyName: propertyData.name,
        });
      } catch (error) {
        console.warn("Failed to generate Ritz-Carlton link:", error);
        return propertyData?.navigationLink || "https://www.marriott.com/";
      }
    }
    return propertyData?.navigationLink || "https://www.marriott.com/";
  };

  const hotelDetailsLink = getHotelDetailsLink();
  return (
    <div
      data-testid="hotel-card"
      className={classNames(
        styles.offersCard,
        ENV.FEATURE_FLAGS.isMapAvailable ? "" : styles.offersCardHalfWidth,
      )}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
      data-hotel-id={propertyData?.id}
    >
      {isPassion && (
        <div className={styles.cardImageChip}>
          <img className={styles.cardChipIcon} src={icon} alt="Golf" />
          <span className={styles.cardChip}>{chip}</span>
        </div>
      )}
      <img
        className={styles.cardImage}
        src={image || placeholderImage}
        alt="hotel image"
      />
      <div className={styles.cardContent}>
        <div className={styles.cardInfo}>
          <h1 className={styles.cardTitle}>
            <a
              className={styles.cardTitleLink}
              href={hotelDetailsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {title}
            </a>
          </h1>
          {rating && (
            <small className={styles.cardRating}>
              {`${rating} ★`} ({reviewCount} Reviews)
            </small>
          )}
          <p className={styles.cardDescription}>{description}</p>
          <a
            href={hotelDetailsLink}
            className={styles.cardLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Hotel Details →
          </a>
        </div>
        <div className={styles.cardFooter}>
          <div className={styles.priceContainer}>
            <div className={styles.priceRow}>
              <span className={styles.priceAmount}>
                {typeof price === "number"
                  ? `$${(price / 100).toFixed(2)}`
                  : price}
              </span>
              <span className={styles.priceUnit}>Per Night</span>
            </div>
            {fee > 0 && (
              <span className={styles.priceFee}>
                Includes ${fee.toFixed(2)} Resort Fee
              </span>
            )}
            {fee <= 0 && (
              <span className={styles.priceFee}>
                Rates may not include applicable Resort Fees
              </span>
            )}
          </div>
          <button
            data-testid="hotel-book"
            className={classNames(styles.bookButton, "custom_click_track")}
            data-custom_click_track_value={`Offer Hotel|Book Now Button|internal|category=ROOM,product=${propertyData?.id || ""}`}
            onClick={() => bookNow(propertyData)}
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
